import React from 'react';
import Button from 'react-bootstrap/Button';
import { FaDownload  } from "react-icons/fa";
import ReactExport from 'react-export-excel';
import moment from 'moment';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const DataReportDetXls = (props) => {


    const headerStyle = {fill: {patternType: "solid", fgColor: {rgb: "FFD364"}},}; //a6c4e4
    const vehCountZone = props.vehCountZone;
    const gapZone = props.gapZone;
    const zone = props.zone;
    const formatDate = props.formatDate;

    const dataVehCountZone = [];
    const dataGapZone = [];
    const dataZone = [];

    const headVehCountZone = [
        [
            {value: "Time", style: headerStyle,},
            {value: "Count", style: headerStyle,}
        ],
    ]

    for (let i = 0; i < vehCountZone.length; i++) {
        dataVehCountZone.push([
            i+":00 - "+ (i+1)+":00",
            vehCountZone[i].veh,
                // {value:dataRaw[i].site_address || "", style: headerStyle},
            ])
    }

    const headZone = [
        [
            {value: "Vehicle", style: headerStyle},
            {value: "Count", style: headerStyle}
        ],
    ]

    if (zone.class[6]===0 && zone.class[8]===0){
        dataZone.push(
            ["Pedestrian",zone.class[0]],
            ["Bike",zone.class[1]],
            ["Motorbike",zone.class[2]],
            ["Car",zone.class[3]],
            ["Van",zone.class[4]],
            ["Short Truck",zone.class[5]],
            ["Long Truck",zone.class[7]],
            ["Undefined",zone.class[9]],
        )
    }else{
        dataZone.push(
            ["Pedestrian",zone.class[0]],
            ["Bike",zone.class[1]],
            ["Motorbike",zone.class[2]],
            ["Car",zone.class[3]],
            ["Van",zone.class[4]],
            ["Short Truck",zone.class[5]],
            ["Med Truck",zone.class[6]],
            ["Long Truck",zone.class[7]],
            ["Bus",zone.class[8]],
            ["Undefined",zone.class[9]],
        )
    }



    const headGapZone = [
        [
            {value: "Date", style: headerStyle},
            {value: "Time", style: headerStyle},
            {value: "Gap", style: headerStyle},
            {value: "Headway", style: headerStyle},
        ],
    ]

    for (let i = 0; i < gapZone.length; i++) {
        dataGapZone.push([
            moment.utc(gapZone[i].date_iso).local().format(formatDate[0]),
            parseInt(moment.utc(gapZone[i].date_iso).local().format('HH'))+":00 - "
                  + (parseInt(moment.utc(gapZone[i].date_iso).local().format('HH'))+1)+":00",
            gapZone[i].gap ? parseFloat(gapZone[i].gap).toFixed(2) : '-',
            gapZone[i].headway ? parseFloat(gapZone[i].headway).toFixed(2) : '-'
            ])
    }

        let dateFrom = ""
        if (props.dateFrom){
            const d = new Date(props.dateFrom);
            dateFrom = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
        }
        let dateTo = ""
        if (props.dateTo){
            const d = new Date(props.dateTo);
            dateTo = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
        }

        const dt = "Date From:" + dateFrom +" to: "+ dateTo

        const dataSet = [
            {   columns: [zone.zone, dt],
                data: [...headVehCountZone,...dataVehCountZone, "",...headZone,...dataZone, "",...headGapZone,...dataGapZone]
            },
        ]

        return (
            <div>
                <ExcelFile filename={zone.zone} element={<Button variant="light"><FaDownload />&nbsp; Download </Button>}>
					<ExcelSheet dataSet={dataSet} name={zone.zone} />
				</ExcelFile>
            </div>
        );
}


export default DataReportDetXls;


